export default "__VITE_ASSET__Z0onn0Dk__"